export default "__VITE_PUBLIC_ASSET__f3bcd1d8__"